const ONES = ["", "bir", "iki", "üç", "dört", "beş", "altı", "yedi", "sekiz", "dokuz"];
const TENS = ["", "on", "yirmi", "otuz", "kırk", "elli", "altmış", "yetmiş", "seksen", "doksan"];
const GROUPS = ["", "bin", "milyon", "milyar", "trilyon"];
const CUR = { TRY: ["Türk Lirası", "Kuruş"], USD: ["ABD Doları", "Sent"], EUR: ["Euro", "Sent"], CNY: ["Çin Yuanı", "Fen"] };

const hundreds = (n) => {
  const h = Math.floor(n / 100), t = Math.floor((n % 100) / 10), o = n % 10;
  return `${h ? (h > 1 ? ONES[h] : "") + "yüz" : ""}${TENS[t]}${ONES[o]}`;
};

export function numberToWords(n) {
  if (n === 0) return "sıfır";
  const parts = [];
  let g = 0;
  while (n > 0) {
    const chunk = n % 1000;
    if (chunk) parts.unshift(g === 1 && chunk === 1 ? "bin" : `${hundreds(chunk)}${GROUPS[g]}`);
    n = Math.floor(n / 1000);
    g += 1;
  }
  return parts.join("");
}

export function amountInWords(amount, currency = "TRY") {
  const [main, sub] = CUR[currency] || [currency, ""];
  const cents = Math.round(Math.abs(Number(amount) || 0) * 100);
  const whole = Math.floor(cents / 100), frac = cents % 100;
  return `Yalnız ${numberToWords(whole)} ${main}${frac ? ` ${numberToWords(frac)} ${sub}` : ""}`;
}
